export type SsoCookieEnv = 'dev' | 'qa' | 'uat' | 'prd';

export const LEGACY_SSO_JWT_COOKIE = 'jwtAuth';
export const LEGACY_SSO_PROJECTS_INFO_COOKIE = 'projectsInfo';

const VALID_ENVS: ReadonlySet<string> = new Set(['dev', 'qa', 'uat', 'prd']);

/**
 * Resolve SSO cookie env suffix from hostname (or VITE_SSO_COOKIE_ENV override).
 * Shared names would bleed across Dev/QA/UAT/Prd on `.falconbrick.com`.
 */
export function resolveSsoCookieEnv(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): SsoCookieEnv {
  const override = (import.meta.env.VITE_SSO_COOKIE_ENV as string | undefined)?.trim().toLowerCase() ?? '';
  if (VALID_ENVS.has(override)) {
    return override as SsoCookieEnv;
  }

  const host = (hostname || '').toLowerCase();
  if (!host || host === 'localhost' || host === '127.0.0.1' || !host.includes('falconbrick.com')) {
    return 'dev';
  }
  if (host.startsWith('dev.')) {
    return 'dev';
  }
  if (host.startsWith('qa.')) {
    return 'qa';
  }
  if (host.startsWith('uat.')) {
    return 'uat';
  }
  return 'prd';
}

export function ssoJwtCookieName(env: SsoCookieEnv = resolveSsoCookieEnv()): string {
  return `jwtAuth_${env}`;
}

export function ssoProjectsInfoCookieName(env: SsoCookieEnv = resolveSsoCookieEnv()): string {
  return `projectsInfo_${env}`;
}
